import {satGlobals} from "../../../../../sat/helper/sat-globals";

export default {
    props: {},
    data() {
        return {};
    },
    created: function () {},
    mounted: function () {},

    methods: {},
    computed: {
        projectName() {
            return satGlobals.getProjectName();
        },
        isRegisteredUser() {
            return this.user?.isRegistered();
        },
        isLegacyUser() {
            if (this.user === null) {
                return false;
            }

            return this.user.isLegacySubscription();
        },
        wasPremiumUser() {
          if (this.user === null) {
              return false;
          }

          return this.user.isWasPremium();
        },
        isFreeUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isPremium() === false && this.user.isEducational() === false;
        },
        isStarterUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isStarter() === true;
        },
        isProUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isPro() === true;
        },
        isUltimateUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isUltimate() === true;
        },
        isPremiumUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isPremium();
        },
        isEducationalUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isEducational();
        },
        isProAndAboveUser() {
            if (this.user === null) {
                return false;
            }
            return this.user.isPro() === true || this.user.isUltimate() === true;
        },
        isStarterAndAboveUser() {
            if (this.user === null) {
                return false;
            }
            return (
                this.user.isPro() === true ||
                this.user.isUltimate() === true ||
                this.user.isStarter() === true ||
                this.user.isEducational() === true
            );
        },
        userAvailableCredits() {
            return this.user?.getAvailableCredits();
        },
        userAvailableCreditsOnceActive() {
            return this.user?.getAvailableCreditsOnceActive();
        },
    },
};
